import { render, staticRenderFns } from "./BirthdayPicker.vue?vue&type=template&id=28eb485a"
import script from "./BirthdayPicker.vue?vue&type=script&lang=js"
export * from "./BirthdayPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports